/**
 * Persist the agent's Available / Away preference across reloads.
 * Default is Away so idle logged-in sessions do not receive round-robin chats.
 */

const KEY = "sentrodesk.agentPresence.status";

/** @typedef {"available" | "away"} AgentPresenceStatus */

/** @returns {AgentPresenceStatus} */
export function readStoredPresenceStatus() {
  try {
    const raw = String(localStorage.getItem(KEY) || "").trim().toLowerCase();
    if (raw === "available" || raw === "online" || raw === "active") return "available";
    if (raw === "away" || raw === "offline") return "away";
  } catch {
    /* ignore */
  }
  return "away";
}

/** @param {AgentPresenceStatus} status */
export function writeStoredPresenceStatus(status) {
  try {
    localStorage.setItem(KEY, status === "available" ? "available" : "away");
  } catch {
    /* ignore */
  }
}
